import React from 'react';
import { QuoteIcon, VideoIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
const TESTIMONIAL_VIDEO = 'https://cdn.magicpatterns.com/uploads/vvWe3sppSeSNzkE1N3xNbf/video%20conto%202.mp4';
export function Testimonials() {
  return <section id="testimonios" className="bg-sage-50" data-id="element-160" data-mp="3fxb2ghka7obn">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:px-8 lg:py-28" data-id="element-161" data-mp="3azj9dk7whw5v">
        <div className="max-w-3xl" data-id="element-162" data-mp="36zilza2tqamo">
          <h2 className="font-display text-2xl font-semibold leading-snug text-emerald-900 sm:text-4xl" data-id="element-163" data-mp="36zr3jf9w6447">
            Lo que dicen de nosotros
          </h2>
          <div className="hairline mt-6 h-px w-32" aria-hidden="true" data-id="element-164" data-mp="2x0jlies7plar" />
          <p className="mt-6 text-base leading-relaxed text-graphite-700" data-id="element-165" data-mp="2x2mnlx6n34vu">
            Experiencias personales compartidas por quienes asistieron a
            consulta.
          </p>
        </div>

        <div className="mt-12 grid gap-8 lg:grid-cols-3" data-id="element-166" data-mp="v7c6l6gih5pe">
          {testimonials.map(testimonial => <figure key={testimonial.id} className="flex h-full flex-col rounded-sm border border-sage-200 bg-ivory-50 p-7 shadow-[0_2px_10px_rgba(28,32,27,0.05)]" data-id="element-167" data-mp="q8irxaphn8nn">
              <QuoteIcon className="h-6 w-6 text-gold-500" aria-hidden="true" data-id="element-168" data-mp="77s8q2mgih1e" />
              <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-graphite-700" data-id="element-169" data-mp="79v99gl8jskd">
                “{testimonial.quote}”
              </blockquote>
              <figcaption className="mt-7 flex items-center gap-4 border-t border-sage-200 pt-6" data-id="element-170" data-mp="zxh9qfz62h30">
                <img src={testimonial.avatar} alt={`Retrato de ${testimonial.name}`} className="h-12 w-12 flex-none rounded-full object-cover ring-1 ring-gold-400/60" loading="lazy" decoding="async" data-id="element-171" data-mp="14uhg6rzxhlun" />
                <span className="flex flex-col" data-id="element-172" data-mp="1iuihg8k3uvan">
                  <span className="text-sm font-semibold text-emerald-900" data-id="element-173" data-mp="1nm0iewm4ovvm">
                    {testimonial.name}
                  </span>
                  <span className="mt-0.5 text-xs uppercase tracking-[0.16em] text-graphite-700/70" data-id="element-174" data-mp="1xgxz5a3gu7mf">
                    {testimonial.location}
                  </span>
                </span>
              </figcaption>
            </figure>)}
        </div>

        <div className="mt-10 overflow-hidden rounded-sm border border-sage-200 bg-ivory-50" data-id="element-175" data-mp="1jihstk9imj4t">
          <div className="flex items-center gap-3 border-b border-sage-200 px-7 py-5" data-id="element-176" data-mp="1ej4vg5l0ptnz">
            <VideoIcon className="h-5 w-5 flex-none text-gold-600" aria-hidden="true" data-id="element-177" data-mp="1ekzj3rnobzvr" />
            <h3 className="font-display text-xl font-semibold text-emerald-900" data-id="element-178" data-mp="19qbrhjxdipcy">
              Video de testimonios
            </h3>
          </div>
          <video src={TESTIMONIAL_VIDEO} controls playsInline preload="metadata" className="block max-h-[640px] w-full bg-emerald-900" data-id="element-179" data-mp="10sj9u946j5me">
            Tu navegador no admite la reproducción de video.
          </video>
        </div>
      </div>
    </section>;
}